import styled from 'styled-components'

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  min-height: 104px;
  > div {
    width: 75%;
  }
`

const StyledTitle = styled.span`
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-weight: 500px;
  margin: 0;
  word-wrap: 'break-word';
`

export { StyledContainer, StyledTitle }
